import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SpecimenLabel } from "../SpecimenLabel";
import PraiseLogo from "@/components/PraiseLogo";

interface FrameDeploymentProps {
  isLoggedIn: boolean;
}

export const FrameDeployment = ({ isLoggedIn }: FrameDeploymentProps) => {
  return (
    <section className="py-32 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      <div className="max-w-4xl mx-auto text-center relative z-10">
        {/* Subtle radiating lines */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          {[...Array(6)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute h-px bg-brand-600/20"
              style={{
                width: "50%",
                transformOrigin: "left center",
                left: "50%",
                rotate: `${i * 30 - 75}deg`
              }}
              initial={{ scaleX: 0, opacity: 0 }}
              whileInView={{ scaleX: 1, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 + i * 0.1, duration: 0.6 }}
            />
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative"
        >
          <div className="flex justify-center mb-8">
            <PraiseLogo size={48} />
          </div>
          
          <p className="text-xl md:text-2xl text-muted-foreground mb-4">
            Your praise is dormant.
          </p>
          <p className="font-editorial text-2xl md:text-3xl text-foreground mb-12">
            Your competitors are deploying.
          </p>

          <Link to={isLoggedIn ? "/agent" : "/auth"}>
            <Button size="lg" className="gradient-brand text-white text-lg px-10 py-6 shadow-brand">
              Start Extracting
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>

          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            className="mt-6 text-sm text-muted-foreground"
          >
            3 free. No card required.
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};
